import { Injectable } from '@angular/core';

@Injectable()
export class AppSettings {
    //public static API_ENDPOINT:string = "http://localhost/admintestsite"; 
    //public static API_ENDPOINT:string = "http://107.21.92.27";
    public static API_ENDPOINT:String = "";

    constructor() {}

    public static getAPI_ENDPOINT() {
        var defaultPorts = {"http:":80,"https:":443};

        // return window.location.protocol + "//" + window.location.hostname
        // + (((window.location.port)
        //     && (window.location.port != defaultPorts[window.location.protocol]))
        //     ? (":"+window.location.port) : "");
        var url_endpoint = window.location.href.split("/FindArticles.aspx")[0];
        url_endpoint = url_endpoint.indexOf('localhost') != -1 ? "http://107.21.92.27" : url_endpoint;
        
        return url_endpoint; 
    }
} 


// WEBPACK FOOTER //
// C:/Workspaces/Redjurista/MAIN/Source/Asterysco.AJ.Lawtheque/GUI/Angular Components/findarticles/src/app/services/config.services.ts